import React, { useState, Component } from 'react';
import { X, ChevronLeft, ChevronRight, FileText, Building2, AlertCircle, Scale } from 'lucide-react';
import { motion } from 'framer-motion';
interface LegalFiling {
  type: 'lien' | 'ucc' | 'bankruptcy' | 'lawsuit';
  title: string;
  icon: ComponentType<{
    className?: string;
  }>;
  fields: Array<{
    label: string;
    value: string;
    hasStatusDot?: boolean;
    statusColor?: 'green' | 'gray' | 'blue' | 'red';
  }>;
}
const dunderFilings: LegalFiling[] = [{
  type: 'lien',
  title: 'Lien Details',
  icon: FileText,
  fields: [{
    label: 'Jurisdiction:',
    value: 'LACKAWANNA COUNTY RECORDER'
  }, {
    label: 'Filing Type:',
    value: 'STATE TAX LIEN'
  }, {
    label: 'Status:',
    value: 'Released',
    hasStatusDot: true,
    statusColor: 'green'
  }, {
    label: 'Filed Date:',
    value: '4/25/2016'
  }, {
    label: 'Amount:',
    value: '$1,118'
  }]
}, {
  type: 'ucc',
  title: 'UCC Details',
  icon: Building2,
  fields: [{
    label: 'Jurisdiction:',
    value: 'SEC OF STATE PA'
  }, {
    label: 'Status:',
    value: 'Active',
    hasStatusDot: true,
    statusColor: 'green'
  }, {
    label: 'Filed Date:',
    value: '2/14/2023'
  }, {
    label: 'Secured Party:',
    value: 'DE LAGE LANDEN FINANCIAL SERVICES INC'
  }, {
    label: 'Collateral:',
    value: 'OFFICE EQUIPMENT INCLUDING COPIERS AND PRINTERS'
  }]
}, {
  type: 'lawsuit',
  title: 'Lawsuit Details',
  icon: Scale,
  fields: [{
    label: 'Case Name:',
    value: 'SCRANTON BUSINESS PARK V. DUNDER MIFFLIN INC.'
  }, {
    label: 'Court:',
    value: 'DISTRICT COURT, LACKAWANNA COUNTY, PENNSYLVANIA'
  }, {
    label: 'Case Type:',
    value: 'CIVIL LAWSUIT - LEASE DISPUTE'
  }, {
    label: 'Status:',
    value: 'Settled',
    hasStatusDot: true,
    statusColor: 'green'
  }, {
    label: 'Filed Date:',
    value: '6/10/2019'
  }, {
    label: 'Resolution Date:',
    value: '9/15/2019'
  }, {
    label: 'Outcome:',
    value: 'Case settled. Parties reached mutual agreement on lease terms and payment schedule.'
  }]
}];
const wonkaFilings: LegalFiling[] = [{
  type: 'lien',
  title: 'Lien Details',
  icon: FileText,
  fields: [{
    label: 'Jurisdiction:',
    value: 'DAUPHIN COUNTY RECORDER'
  }, {
    label: 'Filing Type:',
    value: "MECHANIC'S LIEN"
  }, {
    label: 'Status:',
    value: 'Released',
    hasStatusDot: true,
    statusColor: 'green'
  }, {
    label: 'Filed Date:',
    value: '3/22/2017'
  }, {
    label: 'Release Date:',
    value: '4/10/2017'
  }, {
    label: 'Amount:',
    value: '$8,500'
  }, {
    label: 'Notes:',
    value: 'Construction lien released after prompt payment'
  }]
}, {
  type: 'lawsuit',
  title: 'Lawsuit Details',
  icon: Scale,
  fields: [{
    label: 'Case Name:',
    value: 'SLUGWORTH V. WONKA INDUSTRIES INC.'
  }, {
    label: 'Court:',
    value: 'DISTRICT COURT, DAUPHIN COUNTY, PENNSYLVANIA'
  }, {
    label: 'Case Type:',
    value: 'CIVIL LAWSUIT - TRADE SECRET THEFT'
  }, {
    label: 'Status:',
    value: 'Dismissed',
    hasStatusDot: true,
    statusColor: 'green'
  }, {
    label: 'Filed Date:',
    value: '3/15/2018'
  }, {
    label: 'Resolution Date:',
    value: '8/22/2018'
  }, {
    label: 'Outcome:',
    value: 'Case dismissed with prejudice. Plaintiff failed to provide evidence of trade secret misappropriation.'
  }]
}, {
  type: 'ucc',
  title: 'UCC Details',
  icon: Building2,
  fields: [{
    label: 'Jurisdiction:',
    value: 'SEC OF STATE PA'
  }, {
    label: 'Status:',
    value: 'Active',
    hasStatusDot: true,
    statusColor: 'blue'
  }, {
    label: 'Filed Date:',
    value: '6/12/2024'
  }, {
    label: 'Secured Party:',
    value: 'PNC EQUIPMENT FINANCE'
  }, {
    label: 'Collateral:',
    value: 'CONFECTIONERY PRODUCTION EQUIPMENT AND MACHINERY'
  }, {
    label: 'Amount Secured:',
    value: '$2,500,000'
  }]
}];
const initechFilings: LegalFiling[] = [{
  type: 'lien',
  title: 'Lien Details',
  icon: FileText,
  fields: [{
    label: 'Jurisdiction:',
    value: 'TRAVIS COUNTY RECORDER'
  }, {
    label: 'Filing Type:',
    value: 'STATE TAX LIEN'
  }, {
    label: 'Status:',
    value: 'Active',
    hasStatusDot: true,
    statusColor: 'red'
  }, {
    label: 'Filed Date:',
    value: '11/15/2025'
  }, {
    label: 'Amount:',
    value: '$45,800'
  }, {
    label: 'Debtor:',
    value: 'INITECH CORPORATION'
  }]
}, {
  type: 'ucc',
  title: 'UCC Details',
  icon: Building2,
  fields: [{
    label: 'Jurisdiction:',
    value: 'SEC OF STATE TX'
  }, {
    label: 'Status:',
    value: 'Active',
    hasStatusDot: true,
    statusColor: 'red'
  }, {
    label: 'Filed Date:',
    value: '10/5/2025'
  }, {
    label: 'Secured Party:',
    value: 'AUSTIN COMMUNITY BANK'
  }, {
    label: 'Collateral:',
    value: 'ALL BUSINESS ASSETS AND EQUIPMENT'
  }, {
    label: 'Amount Secured:',
    value: '$150,000'
  }, {
    label: 'Notes:',
    value: 'Blanket lien on all company assets'
  }]
}, {
  type: 'lawsuit',
  title: 'Lawsuit Details',
  icon: Scale,
  fields: [{
    label: 'Case Name:',
    value: 'EMPLOYEE CLASS ACTION V. INITECH CORPORATION'
  }, {
    label: 'Court:',
    value: 'DISTRICT COURT, TRAVIS COUNTY, TEXAS'
  }, {
    label: 'Case Type:',
    value: 'CIVIL LAWSUIT - WRONGFUL TERMINATION'
  }, {
    label: 'Status:',
    value: 'Active',
    hasStatusDot: true,
    statusColor: 'red'
  }, {
    label: 'Filed Date:',
    value: '9/22/2025'
  }, {
    label: 'Plaintiffs:',
    value: '47 former employees'
  }, {
    label: 'Amount Claimed:',
    value: '$2,500,000'
  }, {
    label: 'Allegations:',
    value: 'Mass layoffs without proper notice, unpaid severance, and discriminatory termination practices.'
  }]
}];
interface LegalFilingsModalProps {
  onClose: () => void;
  initialIndex?: number;
  company?: 'dunder' | 'wonka' | 'initech';
}
export function LegalFilingsModal({
  onClose,
  initialIndex = 0,
  company = 'dunder'
}: LegalFilingsModalProps) {
  const filings = company === 'wonka' ? wonkaFilings : company === 'initech' ? initechFilings : dunderFilings;
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const currentFiling = filings[currentIndex];
  const Icon = currentFiling.icon;
  const handlePrevious = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };
  const handleNext = () => {
    if (currentIndex < filings.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-id="element-2657" data-mp="1g0bu420r4u2d">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} animate={{
      opacity: 1,
      scale: 1
    }} exit={{
      opacity: 0,
      scale: 0.95
    }} className="bg-white rounded-lg shadow-xl w-full max-w-2xl" data-id="element-2658" data-mp="rafujs9ezz23">
        {/* Header */}
        <div className="px-4 py-3 border-b border-gray-200 flex items-center justify-between" data-id="element-2659" data-mp="cmcko7s94380">
          <div className="flex items-center gap-3" data-id="element-2660" data-mp="1a7h31n26ghas">
            <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center shrink-0" data-id="element-2661" data-mp="159p7mj2bqd1u">
              <Icon className="w-5 h-5 text-gray-500" data-id="element-2662" data-mp="10acdred1c5pr" />
            </div>
            <h2 className="text-lg font-bold text-gray-900" data-id="element-2663" data-mp="10cfd4p02vb75">
              {currentFiling.title}
            </h2>
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-colors" data-id="element-2664" data-mp="3l1ct9ibw0j5c">
            <X className="w-5 h-5" data-id="element-2665" data-mp="3g0ysmlcm8bhc" />
          </button>
        </div>

        {/* Body */}
        <div className="px-4 py-4" data-id="element-2666" data-mp="1vl0szacj13ut">
          <div className="space-y-0" data-id="element-2667" data-mp="1vhmsk7nfb4q0">
            {currentFiling.fields.map((field, index) => <div key={index} className="grid grid-cols-[140px_1fr] gap-4 py-2.5 border-b border-gray-100 last:border-b-0" data-id="element-2668" data-mp="20gpsxesgkmrn" data-mpi={index}>
                <div className="font-semibold text-gray-900 text-sm" data-id="element-2669" data-mp="2aa6qmtvpum0l">
                  {field.label}
                </div>
                <div className="text-gray-900 text-sm flex items-center gap-2" data-id="element-2670" data-mp="2f9rot232aqc9">
                  {field.hasStatusDot && <div className={`w-2 h-2 rounded-full ${field.statusColor === 'green' ? 'bg-green-500' : field.statusColor === 'blue' ? 'bg-blue-500' : field.statusColor === 'red' ? 'bg-red-500' : 'bg-gray-400'}`} data-id="element-2671" data-mp="2o8mwyjpo2ai7" />}
                  {field.value}
                </div>
              </div>)}
          </div>
        </div>

        {/* Footer */}
        <div className="px-4 py-3 border-t border-gray-200 flex items-center justify-center gap-3" data-id="element-2672" data-mp="23m9llpl21dd3">
          <button onClick={handlePrevious} disabled={currentIndex === 0} className={`px-4 py-2 rounded-lg text-sm font-medium flex items-center gap-2 transition-colors ${currentIndex === 0 ? 'bg-gray-200 text-gray-400 cursor-not-allowed' : 'bg-gray-200 text-gray-600 hover:bg-gray-300'}`} data-id="element-2673" data-mp="28jrlkqh3gi8y">
            <ChevronLeft className="w-4 h-4" data-id="element-2674" data-mp="2mk2cftielwu4" />
            PREVIOUS
          </button>
          <button onClick={handleNext} disabled={currentIndex === filings.length - 1} className={`px-4 py-2 rounded-lg text-sm font-medium flex items-center gap-2 transition-colors ${currentIndex === filings.length - 1 ? 'bg-gray-200 text-gray-400 cursor-not-allowed' : 'bg-indigo-600 text-white hover:bg-indigo-700'}`} data-id="element-2675" data-mp="2rhudpe4xuvaz">
            NEXT
            <ChevronRight className="w-4 h-4" data-id="element-2676" data-mp="3aay7r0m2ja64" />
          </button>
        </div>
      </motion.div>
    </div>;
}